exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cloudAdmin-sidenav{background-color:#373737;color:#fff;padding:8px}.cloudAdmin-sidenav md-list md-list-item.md-2-line .md-list-item-text h3{color:#fff;font-size:16px;text-transform:uppercase}.cloudAdmin-sidenav md-list md-list-item.md-2-line .md-list-item-text p{color:#8a8a8a;font-size:14px}.cloudAdmin-sidenav md-icon,.cloudAdmin-sidenav md-icon.md-default-theme{color:#fff}.cloudAdmin-sidenav md-list md-list-item.md-2-line{border-left:2px solid transparent}.cloudAdmin-sidenav md-list md-list-item.md-2-line:hover{border-left:2px solid #3292d3;color:#3292d3}.cloudAdmin-sidenav md-list md-list-item.md-2-line.active-state h3{color:#3292d3}.cloudAdmin-sidenav md-list md-list-item.md-2-line.active-state p{color:#fff}.cloudAdmin-sidenav md-list md-list-item.md-2-line.active-state md-icon{color:#3292d3}.cloudAdmin-sidenav md-list md-list-item.md-2-line.active-state{border-left:2px solid #3292d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./app/layout/sidenav/sidenav.less
// module id = ./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/layout/sidenav/sidenav.less
// module chunks = 8